import React, {memo, useState, useMemo, useCallback} from "react"
import {useHistory} from "react-router"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {useLocalization} from "../../../../hooks/localization"
import {CallListModel} from "../../../../types/control"
import {useSortBySelector} from "../../../../hooks/sort-by-selector"
import {useSelector} from "react-redux"
import "./index.scss"
const keyExtractor = (item: CallListModel) => item.id

export const CallListScreen = memo(function CallListScreen() {
    const {t} = useLocalization()
    const history = useHistory()
    const [selectedSearchList, setSelectedSearchList] = useState<CallListModel>(null)
    const allSearchList = useSortBySelector(
        state => state.control.callListList,
        control => control.id
    )
    const gatewayList = useSelector(state => state.control.gatewayList)
    const test = {...gatewayList}
    const findSipStatus = test[0].settings?.sip?.has_sip

    const onCopyClick = useCallback(
        () => history.push({pathname: "/settings/intercom/call-list/edit", state: {...selectedSearchList, id: null}}),
        [history, selectedSearchList]
    )

    const buttons = useMemo(
        () => [
            {
                text: t("copy"),
                onClick: onCopyClick,
                className: "blue",
                hidden: !selectedSearchList
            },
            {
                text: t("edit"),
                url: `/settings/intercom/call-list/edit/${selectedSearchList ? selectedSearchList.id : ""}`,
                className: "orange",
                hidden: !selectedSearchList
            },
            {
                text: t("add_device"),
                url: "/settings/intercom/call-list/edit",
                className: "green",
                hidden: findSipStatus
            }
        ],
        [t, onCopyClick, selectedSearchList, findSipStatus]
    )

    const displayNameExtractor = useCallback((item: CallListModel, column: ColumnModel) => {
        if (column.key === "button") {
            return item.button
        }

        return item[column.key]
    }, [])

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 2,
                name: t("button"),
                key: "button"
            },
            {
                length: 3,
                name: t("device"),
                key: "sought_ip"
            }
        ],
        [t]
    )

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className="camera-list-page"
                backUrl={"/settings/intercom"}
                searchable={false}
            >
                {renderIf(!findSipStatus)(
                    () => (
                        <SettingsList
                            columns={columns}
                            items={allSearchList}
                            displayNameExtractor={displayNameExtractor}
                            keyExtractor={keyExtractor}
                            selectedItem={selectedSearchList}
                            onItemSelected={setSelectedSearchList}
                        />
                    ),
                    () => (
                        <div className="cannot-use">Bu sayfa kullanılamıyor.</div>
                    )
                )}
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
